/** Allowlisted guide ids. The orchestrator may only start one of these. */
export const GUIDE_IDS = ['workOrder.create', 'quote.create'] as const;

export type GuideId = (typeof GUIDE_IDS)[number];

export type GuideContext = Record<string, unknown>;

export type GuideStepAction =
  | { type: 'navigate'; to: string }
  | { type: 'focus' };

/**
 * One spotlight in a guide.
 * `doneWhen` absent: the user advances with the popover Next button.
 * `next` absent or returning null: the guide finishes.
 */
export interface GuideStep {
  id: string;
  anchor: string;
  /** Key in the `guides` i18n namespace. */
  textKey: string;
  onEnter?: GuideStepAction[];
  doneWhen?: string;
  next?: string | ((ctx: GuideContext) => string | null);
}

export interface GuideDefinition {
  id: GuideId;
  /** Key in the `guides` i18n namespace. */
  titleKey: string;
  firstStep: string;
  steps: GuideStep[];
  /** Key in the `guides` i18n namespace, posted to the chat when the guide finishes. */
  doneTextKey: string;
}

/** A guide that is currently walking the user. */
export interface GuideRun {
  guide: GuideDefinition;
  stepId: string;
  ctx: GuideContext;
  history: string[];
}
